import {
    SpinButtonBaseViewMobile, SpinButtonEvents,
    SpinButtonModule,
    SpinButtonView,
    SpinButtonViewEvents,
    SpinButtonViewMobile
} from '@gongxigames/framework/slot/modules/spinbutton';
import {UIDisableReason} from '@gongxigames/framework/slot/modules/keypad';
import {ReelsEvents} from '@gongxigames/framework/slot/modules/reels';
import {ModuleState} from '@gongxigames/framework/slot/fragments/module/ModuleState';

// @ts-ignore
// TODO: refactor required
export class SpinButtonWhileSpinningState extends ModuleState<SpinButtonView|SpinButtonViewMobile, SpinButtonModule> {
    protected isWait = false;
    protected allReelsStopped = false;
    public onEnterState(): void {
        this.allReelsStopped = false;

        if (this.module.roundDelay > 0) {
            this.module.updateManager.addTimer(this.onCompleteRoundDelay.bind(this), this.module.roundDelay, true);
            this.isWait = true;
        }

        if (this.module.quickStopDisabled) {
            this.module.disableButton(UIDisableReason.DISABLED_QUICK_STOP);
        }
    }

    public onLeaveState(): void {
    }

    protected setupEvents(): void {
        this.setEventHandler(ReelsEvents.SPIN_ENDED, this.onAllReelsStopped.bind(this));
        this.setEventHandler(SpinButtonViewEvents.SPIN_BUTTON_CLICKED, this.onSpinsLeftButtonClicked.bind(this));
        this.setEventHandler(SpinButtonBaseViewMobile.SPINS_LEFT_BUTTON_CLICKED, this.onSpinButtonClicked.bind(this));
    }

    protected onCompleteRoundDelay(): void {
        this.module.enableButton(UIDisableReason.ROUND_DELAY);
        this.isWait = false;
        this.gotoBasicState();
    }

    protected onAllReelsStopped(): void {
        this.module.enableButton(UIDisableReason.QUICK_STOP);

        if (this.isWait) {
            this.module.disableButton(UIDisableReason.ROUND_DELAY);
        }

        if (this.module.quickStopDisabled) {
            this.module.enableButton(UIDisableReason.DISABLED_QUICK_STOP);
        }

        this.allReelsStopped = true;
        this.gotoBasicState();
    }

    protected onSpinButtonClicked(): void {
        this.module.disableButton(UIDisableReason.QUICK_STOP);
        this.emit(SpinButtonEvents.SPIN_BUTTON_PRESSED);
    }

    protected onSpinsLeftButtonClicked(): void {
        this.onSpinButtonClicked();
    }

    protected gotoBasicState(): void {
        if (!this.isWait && this.allReelsStopped && this.module.currentState.name === this.name) {
            this.module.gotoState(SpinButtonModule.BASIC_STATE);
        }
    }
}
